function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-family: inherit;\n\n  &:not(:focus) {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
var HiddenInput = styled.input(_templateObject(), function(props) {
    return props.theme.palette.lightBlue;
});
export default HiddenInput;
